import React, { FunctionComponent, memo } from 'react';
import { Grid, Typography, Link as MaterialLink } from '@material-ui/core';
import clsx from 'clsx';
import summaryLinksStyles from '../summaryLinksStyles';
import Translation from '../../../../../../../common/components/translation/Translation';
import TestDriveIcon from './TestDriveIcon';
import dxpDigitalDataAssignment from '../../../../../../../../../common/utilities/dxpDigitalDataAssignment';
import { DxpDataLayerEventNames } from '../../../../../../../../../common/utilities/customDatalayerInterface';
import useDxpDataLayer from '../../../../../../../common/hooks/useDxpDataLayer';

interface ISummaryTestDriveLinkProps {
  testDriveUrl?: string;
  centered?: boolean;
}

const SummaryTestDriveLink: FunctionComponent<ISummaryTestDriveLinkProps> = memo(({ testDriveUrl, centered }) => {
  const styles = summaryLinksStyles();
  const { commonEventPayload, accessories } = useDxpDataLayer();

  const onClick = () => {
    dxpDigitalDataAssignment({
      eventName: DxpDataLayerEventNames.CONFIGURATOR_TEST_DRIVE,
      ...commonEventPayload,
      accessories,
    });
  };

  return (
    <MaterialLink
      href={testDriveUrl}
      target="_blank"
      className={clsx([styles.newLink, styles.noUnderline])}
      data-test={'summary:link:test_drive'}
      onClick={onClick}
    >
      <Grid item xs={12} className={centered ? styles.itemCentered : styles.item}>
        <TestDriveIcon />
        <Typography variant={'caption'} className={styles.summaryText}>
          <Translation id={'trans__configurator__customise_page_summary_section__book_a_test_drive_link'} />
        </Typography>
      </Grid>
    </MaterialLink>
  );
});

export default SummaryTestDriveLink;
